import { call, put } from 'redux-saga/effects';
import GetMyAppointmentsActions from '../redux/GetMyAppointmentsRedux';
import { api } from './api';

export function* getMyAppointments(action: any): Generator<any, void, any> {
  const { data } = action;
  const response = yield call(api.getMyAppointments, data);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(GetMyAppointmentsActions.getMyAppointmentsSuccess(response.data.data));
  } else {
    yield put(GetMyAppointmentsActions.getMyAppointmentsFailure());
  }
}